import {
  commonTableBodyStyles,
  commonTableHeadStyles,
  tableContainerStyles,
} from '../commonStyled';

export const cureTableContainerStyles = {
  ...tableContainerStyles,

  minWidth: '982px',
};

const getColumnWidths = ({ isInitialLeColumnShown, hasPendingChanges }) => {
  if (hasPendingChanges) {
    return {
      first: isInitialLeColumnShown ? '26%' : '34%',
      second: '14%',
      third: '14%',
      fourth: isInitialLeColumnShown ? '14%' : '18%',
      fifth: isInitialLeColumnShown ? '18%' : '14%',
      sixth: '14%',
    };
  }

  return {
    first: isInitialLeColumnShown ? '32%' : '52%',
    second: '14%',
    third: '20%',
    fourth: isInitialLeColumnShown ? '20%' : '14%',
    fifth: '14%',
  };
};

const getCommonCellStyles = ({ isInitialLeColumnShown = true, hasPendingChanges = false }) => {
  const widths = getColumnWidths({ isInitialLeColumnShown, hasPendingChanges });

  return {
    width: '200px',
    borderColor: ({ palette }) => `${palette.border.default} !important`,

    '&:first-of-type': { width: widths.first },
    '&:nth-of-type(2)': { width: widths.second },
    '&:nth-of-type(3)': { width: widths.third },
    '&:nth-of-type(4)': { width: widths.fourth },
    '&:nth-of-type(5)': { width: widths.fifth },
    ...(widths.sixth && { '&:nth-of-type(6)': { width: widths.sixth } }),
  };
};

const commonTextStyles = {
  fontSize: '1.4rem',
};

export const getTableHeadStyles = ({
  isInitialLeColumnShown = true,
  hasPendingChanges = false,
}) => ({
  '& .table-cell': {
    ...getCommonCellStyles({ isInitialLeColumnShown, hasPendingChanges }),
    ...commonTextStyles,
    ...commonTableHeadStyles,
  },
});

export const getTableBodyStyles = ({
  isInitialLeColumnShown = true,
  hasPendingChanges = false,
}) => ({
  '& .table-cell': {
    ...getCommonCellStyles({ isInitialLeColumnShown, hasPendingChanges }),
    ...commonTextStyles,
    ...commonTableBodyStyles,
  },
});

export const totalRowsStyles = {
  '& .table-cell': {
    padding: '12px 15px',
  },
};

export const getTableFooterStyles = ({
  isInitialLeColumnShown = true,
  hasPendingChanges = false,
}) => ({
  '& .table-cell': {
    ...getCommonCellStyles({ isInitialLeColumnShown, hasPendingChanges }),
    ...commonTextStyles,
    padding: '12px 15px',
    fontWeight: 700,
    lineHeight: '2.2rem',
    color: ({ palette }) => palette.text.primary,

    '&:last-of-type': {
      backgroundColor: ({ palette }) => palette.background.secondary,
    },
  },

  '& .table-row:last-of-type .table-cell': {
    border: 'none',
  },
});

export const texasTableBodyStyles = {
  '& .table-cell': {
    ...commonTextStyles,
    padding: '12px 15px',
    fontWeight: 400,
    lineHeight: '2.2rem',
    color: ({ palette }) => palette.text.secondary,
    borderColor: ({ palette }) => `${palette.border.default} !important`,

    width: '298px',

    '&:first-of-type': {
      width: '386px',
    },
  },

  '& .table-row:last-of-type .table-cell:last-of-type': {
    fontWeight: 700,
    color: ({ palette }) => palette.text.primary,
  },
};

export const cureHeaderStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
};

export const footerCellStyles = {
  '&:not(:first-of-type)': {
    fontWeight: '700 !important',
    color: ({ palette }) => `${palette.primary.main} !important`,
  },
};
